import React from 'react';
import { UsersIcon, BookOpenIcon, StarIcon, MapPinIcon } from 'lucide-react';
export function SocialProofBar() {
  return <section className="bg-brand-dark text-white py-6 md:py-8 px-4" data-id="element-254">
      <div className="max-w-6xl mx-auto grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-8 text-center" data-id="element-255">
        <div className="flex flex-col items-center justify-center" data-id="element-256">
          <UsersIcon className="w-10 h-10 text-brand-orange mb-3" data-id="element-257" />
          <span className="text-3xl font-black mb-1" data-id="element-258">+1.200</span>
          <span className="text-gray-300 text-sm uppercase tracking-wider font-semibold" data-id="element-259">
            docentes
          </span>
        </div>
        <div className="flex flex-col items-center justify-center" data-id="element-260">
          <BookOpenIcon className="w-10 h-10 text-brand-orange mb-3" data-id="element-261" />
          <span className="text-3xl font-black mb-1" data-id="element-262">5</span>
          <span className="text-gray-300 text-sm uppercase tracking-wider font-semibold" data-id="element-263">
            Tomos listos
          </span>
        </div>
        <div className="flex flex-col items-center justify-center" data-id="element-264">
          <div className="flex text-yellow-400 mb-3" data-id="element-265">
            <StarIcon className="w-8 h-8 fill-current" data-id="element-266" />
            <StarIcon className="w-8 h-8 fill-current" data-id="element-267" />
            <StarIcon className="w-8 h-8 fill-current" data-id="element-268" />
            <StarIcon className="w-8 h-8 fill-current" data-id="element-269" />
            <StarIcon className="w-8 h-8 fill-current" data-id="element-270" />
          </div>
          <span className="text-3xl font-black mb-1" data-id="element-271">4.9/5</span>
          <span className="text-gray-300 text-sm uppercase tracking-wider font-semibold" data-id="element-272">
            calificación
          </span>
        </div>
        <div className="flex flex-col items-center justify-center" data-id="element-273">
          <MapPinIcon className="w-10 h-10 text-brand-orange mb-3" data-id="element-274" />
          <span className="text-3xl font-black mb-1" data-id="element-275">🇦🇷</span>
          <span className="text-gray-300 text-sm uppercase tracking-wider font-semibold" data-id="element-276">
            Docentes de todo el país
          </span>
        </div>
      </div>
    </section>;
}